<template>
     <div class="col-md-12 col-lg-8 mb-3 mb-md-0 w5">
          <div class="card h-100">
            <!--https://bootsnipp.com/snippets/featured/bootstrap-tabs-with-elegant-smooth-design-using-bootstrap-4-->
            <!-- Tab headings -->
            <div class="row">
              <div class="col-sm-12">
                <div class="col-sm-12 ">
                  <nav>
                    <div class="nav nav-tabs nav-fill mt-3" id="nav-tabs-financials" role="tablist">
                      <a class="nav-item nav-link text-sm-left active" id="nav-bills-tab" data-toggle="tab" href="#nav-bills"
                        role="tab" aria-controls="nav-bills" aria-selected="true">Bills</a>
                      <a class="nav-item nav-link text-sm-left" id="nav-transactions-tab" data-toggle="tab" href="#nav-transactions"
                        role="tab" aria-controls="nav-transactions" aria-selected="false">Transactions</a>
                      <a class="nav-item nav-link text-sm-left" id="nav-charges-tab" data-toggle="tab" href="#nav-charges"
                        role="tab" aria-controls="nav-charges" aria-selected="false">Charges</a>
                      <a v-if="useNativeDD" class="nav-item nav-link text-sm-left" id="nav-direct-debits-tab" data-toggle="tab" href="#nav-direct-debits"
                        role="tab" aria-controls="nav-direct-debits" aria-selected="false">Direct Debits</a>
                      <a class="nav-item nav-link text-sm-left" id="writeoffs-tab" data-toggle="tab" href="#writeoffs"
                        role="tab" aria-controls="writeoffs" aria-selected="false">Write-Offs</a>
                    </div>
                  </nav>
                </div>
                <!-- Tab content -->
                <div class="tab-content py-2 px-2 px-sm-0">
                 <bills></bills>
                 <transactions></transactions>
                 <charges></charges>
                 <direct-debits></direct-debits>
                 <writeoffs></writeoffs>
                </div>
              </div>
            </div>
            <!-- ./Tabs -->
          </div>
          <!-- Card close -->
        </div>
</template>

<script>
import Bills from './financeTabs/Bills.vue'
import Transactions from './financeTabs/Transactions.vue'
import Charges from './financeTabs/Charges.vue'
import DirectDebits from './financeTabs/DirectDebits.vue'
import Writeoffs from './financeTabs/Writeoffs.vue'
import Vue from 'vue'

export default {
  props: ['bills'],
  computed: {
    useNativeDD() {
      return Vue.config.honeycomb.useNativeDD;
    },
  },
  components: {
    Bills,
    Transactions,
    Charges,
    DirectDebits,
    Writeoffs
  },
}
</script>
